import createIcon from '../../createIcon';

/**
 * @component @name DoNotDisturbAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjUgMiAyIDYuNSAyIDEyQzIgMTcuNSA2LjUgMjIgMTIgMjJDMTcuNSAyMiAyMiAxNy41IDIyIDEyQzIyIDYuNSAxNy41IDIgMTIgMlpNNCAxMkM0IDcuNiA3LjYgNCAxMiA0QzEzLjggNCAxNS41IDQuNiAxNi45IDUuN0w1LjcgMTYuOUM0LjYgMTUuNSA0IDEzLjggNCAxMlpNMTIgMjBDMTAuMiAyMCA4LjUgMTkuNCA3LjEgMTguM0wxOC4zIDcuMUMxOS40IDguNSAyMCAxMC4yIDIwIDEyQzIwIDE2LjQgMTYuNCAyMCAxMiAyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoNotDisturbAlt = createIcon('DoNotDisturbAlt', [
  [
    'path',
    {
      d: 'M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM4 12C4 7.6 7.6 4 12 4C13.8 4 15.5 4.6 16.9 5.7L5.7 16.9C4.6 15.5 4 13.8 4 12ZM12 20C10.2 20 8.5 19.4 7.1 18.3L18.3 7.1C19.4 8.5 20 10.2 20 12C20 16.4 16.4 20 12 20Z',
      key: 'oo1qs',
    },
  ],
]);

export default DoNotDisturbAlt;
